<!-- Process 5713 Lines Component -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (tags.length > 0) {
<div style="margin-bottom: 10px;">
    Process 5713 all lines data for submissions :
  </div>
}
  @if (tags.length > 0) {

    @for (tag of tags; track $index; let i = $index) {
<div style="margin:0px 5px 5px 0px" 
         class="btn-group btn-group-xs" 
         role="group" 
         aria-label="" 
        >
      <div class="btn btn-xs btn-default"><i class="fa fa-tag"></i></div>
      <div class="btn btn-default btn-xs btn-white">{{tag}}</div>
      <div class="btn btn-danger btn-xs" (click)="removeTag(i)" style="cursor: pointer;"><i class="fa fa-times"></i></div>
    </div>
}
  
}
  @if (tags.length == 0) {
<div class="noIdBlock">
    No ID's selected.
  </div>
}
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" 
          type="button" 
          (click)="process5713LinesData()" 
          [disabled]="tags.length == 0 || saveloader">
    Save and Proceed 
    @if (saveloader) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
  </button>
  <button class="btn btn-warning btn-sm" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

